import { withInstall } from '@ideaz/utils'
import Descriptions from './src/index'

export default withInstall(Descriptions)
export * from './src/descriptions'
